import React, { useMemo, useState } from 'react';
import Tabs from './ui/Tabs';
import ProfileCard from './ui/ProfileCard';
import Card from './ui/Card';
import Button from './ui/Button';
import SectionWrapper from './ui/SectionWrapper';

const tabs = ['ALL', 'Directors', 'Writers', 'Cinematographers', 'Editors', 'Composers', 'More'];

const creators = [
  { name: 'Riya Sharma', role: 'Cinematographer', category: 'Cinematographers', location: 'Mumbai', tone: 'bg-[#E8DCC7]' },
  { name: 'Arjun Mehta', role: 'Director', category: 'Directors', location: 'Delhi', tone: 'bg-[#D7E6E2]' },
  { name: 'Priya Nair', role: 'Screenwriter', category: 'Writers', location: 'Kochi', tone: 'bg-[#E2E2E2]' },
  { name: 'Kabir', role: 'VFX Artist', category: 'More', location: 'Pune', tone: 'bg-[#DFE8E2]' },
  { name: 'Neha Kapoor', role: 'Editor', category: 'Editors', location: 'Bengaluru', tone: 'bg-[#E8E3D6]' },
  { name: 'Rohan Iyer', role: 'Composer', category: 'Composers', location: 'Chennai', tone: 'bg-[#DCE5EC]' },
];

export default function VerifiedCreatorsSection({ onBrowseAll }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeTab = tabs[activeIndex] || 'ALL';
  const filteredCreators = useMemo(() => {
    if (activeTab === 'ALL') return creators.slice(0, 4);

    const matches = creators.filter((creator) => creator.category === activeTab);
    return matches;
  }, [activeTab]);

  return (
    <SectionWrapper className="mt-12">
      <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
        Discover <span className="italic text-[#C8A75B] font-medium">verified creators</span>
      </h2>

      {/* Tabs */}
      <div className="mt-6">
        <Tabs items={tabs} activeIndex={activeIndex} onSelect={setActiveIndex} />
      </div>

      {/* Cards grid */}
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {filteredCreators.map((c) => (
          <ProfileCard key={c.name} name={c.name} role={c.role} location={c.location} tone={c.tone} />
        ))}

        {filteredCreators.length === 0 && (
          <Card className="bg-[#F7F6F3] p-4 flex items-center justify-center sm:col-span-2 lg:col-span-4">
            <p className="text-sm font-medium text-gray-600">No creators available in this category right now.</p>
          </Card>
        )}

        {/* Last "more creators" card */}
        <Card className="bg-[#F7F6F3] p-4 flex flex-col justify-center">
          <p className="text-sm font-semibold text-gray-700">1.4k more creators</p>
          <Button type="button" variant="dark" onClick={onBrowseAll} className="mt-3 text-xs w-fit">
            Browse All →
          </Button>
        </Card>
      </div>
    </SectionWrapper>
  );
}

